import { render } from "./BbBidding.vue?vue&type=template&id=28bfe57f&scoped=true"
import script from "./BbBidding.vue?vue&type=script&lang=js"
export * from "./BbBidding.vue?vue&type=script&lang=js"

import "./BbBidding.vue?vue&type=style&index=0&id=28bfe57f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bfe57f"]])

export default __exports__